import {useState} from 'react'
import {getSupplier} from '../services'
import {SupplierModel, SelectModel} from '../model'
import {mapDataSelect} from '../../../util/functions'
const useSupplierList = () => {
  const [loading, setLoading] = useState(false)
  const [supplierList, setSupplierList] = useState<SelectModel[]>([])

  const getSupplierAPI = async (supplierParams: SupplierModel) => {
    let obj: SupplierModel = {
      isCombo: true,
      ...supplierParams,
    }
    return await getSupplier(obj, 1)
  }

  const getSupplierData = async (supplierParams: SupplierModel) => {
    setLoading(true)
    try {
      const response = await getSupplierAPI(supplierParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching supplier data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const updateSupplierList = (mappedSites: {value: string; label: string}[]) => {
    setSupplierList(mappedSites)
  }
  const getSupplierMappedData = async (supplierParams: SupplierModel) => {
    try {
      const data = await getSupplierData(supplierParams)
      const mappedSites = mapDataSelect(data, 'id', 'razonSocial')
      return mappedSites
    } catch (error) {
      console.error('Error fetching supplier data:', error)
    }
  }
  const getSupplierList = async (supplierParams: SupplierModel = {}) => {
    try {
      const data = await getSupplierData(supplierParams)
      const mappedSites = mapDataSelect(data, 'id', 'razonSocial')
      updateSupplierList(mappedSites)
    } catch (error) {
      console.error('Error fetching supplier data:', error)
    }
  }

  const handleClear = () => {
    setSupplierList([])
  }

  return {
    loading,
    supplierList,
    getSupplierList,
    handleClear,
    getSupplierMappedData,
  }
}

export default useSupplierList
